export const SESSION_BRANCH_UPDATED_EVENT = "cord:session-branch-updated"

export interface SessionBranchUpdatedDetail {
  sessionId: string
  branch: string
  baseBranch?: string | null
  clearBranchSwitchInProgress?: boolean
}

export function dispatchSessionBranchUpdated(
  detail: SessionBranchUpdatedDetail,
): void {
  if (typeof window === "undefined") return
  window.dispatchEvent(
    new CustomEvent<SessionBranchUpdatedDetail>(SESSION_BRANCH_UPDATED_EVENT, {
      detail,
    }),
  )
}
